import { v4 as uuid } from "uuid";

import { initErrorReporting } from "helpers/error_reporting/error_reporting";
import Routes from "routes";

const sessionId = sessionStorage.getItem("sessionId") || uuid();
sessionStorage.setItem("sessionId", sessionId);

initErrorReporting(sessionId);

Routes.dispatch();

if (module.hot) {
  module.hot.accept();
}
